import styled from 'styled-components';

import { marginReplacer, truncateWidth } from 'styles/utils';

const fontColor = {
  primary: 'wfBlack',
  secondary: 'wfWhite',
  tertiary: 'wfGrey',
  accent: 'primary',
  light: 'wfGrey600',
};

export const ParagraphStyled = styled.p`
  display: ${props => props.display};
  margin: ${props => (props.margin ? marginReplacer(props.margin) : '0')};
  margin-top: ${props => props.theme.space[props.mt]};
  margin-left: ${props => props.theme.space[props.ml]};
  font-size: ${props => props.theme.font.size[props.size] || 'inherit'};
  font-weight: ${props => props.theme.font.weight.regular};
  line-height: ${props => props.theme.font.lineHeight.medium};
  color: ${props => props.theme.color[fontColor[props.variant]]};
  text-decoration: ${props => props.textDecoration};
  ${props => props.isTruncated && truncateWidth('100%')};
  & + & {
    margin-top: 1em;
  }
`;
